import { TRANSACTION_SOURCE_TO_LABEL_MAP } from "constants/user";
import { ApiUsersCurrentTransactionSource } from "utils/api/users";

export const RADIO_OPTIONS = [
  {
    value: ApiUsersCurrentTransactionSource.checking,
    heading:
      TRANSACTION_SOURCE_TO_LABEL_MAP[
        ApiUsersCurrentTransactionSource.checking
      ],
    body: "Your Checking Balance alone will be used. You'll be able to see your Earnings Balance, but it won't be available to spend on your card.",
  },
  {
    value: ApiUsersCurrentTransactionSource.flex,
    heading:
      TRANSACTION_SOURCE_TO_LABEL_MAP[ApiUsersCurrentTransactionSource.flex],
    body: "Your Earnings Balance will be used first. If it's too low to fully cover a transaction, your card will automatically route the full transaction to your Checking Balance.",
    showConfigLink: true,
  },
];
